// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: '',
  fileUploadURL: '',
  currencyFormat: 'en-US',
  commonPublisher: '',
  accountsPublisher:'',
  customersPublisher: '',
  depositsPublisher:'',
  cardsPublisher: '',
  loansPublisher:'',
  billpaymentsPublisher:'',
  transfersPublisher:'',
  defaultPublisher: '',
  languageId: '',
  measurementId:'',
  gtagid:''
};
